module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-f3004184f6547dac3646a6797049a1db.jpg";